import { apiPath } from './apiBaseUrl';

export function resolveBrandAssetUrl(url) {
  const raw = String(url || '').trim();
  if (!raw) return '';
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  if (raw.startsWith('/')) return apiPath(raw);
  return '';
}

export function tenantBrand(tenant) {
  return {
    logoUrl: resolveBrandAssetUrl(tenant?.logo_url),
    bannerUrl: resolveBrandAssetUrl(tenant?.banner_url),
    coatOfArmsUrl: resolveBrandAssetUrl(tenant?.coat_of_arms_url),
  };
}

export function hasTenantBrand(tenant) {
  const brand = tenantBrand(tenant);
  return Boolean(brand.logoUrl || brand.bannerUrl || brand.coatOfArmsUrl);
}

export function receiptBrandFromTenant(tenant, orgName) {
  const brand = tenantBrand(tenant);
  return {
    brand: 'useAmbiental',
    orgName: orgName || tenant?.name || 'Licenças Ambientais',
    logoUrl: brand.logoUrl,
    bannerUrl: brand.bannerUrl,
    coatOfArmsUrl: brand.coatOfArmsUrl,
  };
}
